export default "__VITE_ASSET__f5c54720__"